var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":_vm.name,"resizable":_vm.options.resizable,"adaptive":_vm.options.adaptive,"draggable":_vm.resizeScreen,"classes":_vm.options.classes,"width":_vm.options.width,"height":_vm.options.height,"click-to-close":_vm.options.clickToClose}},[_vm._t("default",null,{"closeModal":_vm.closeModal})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }